import type { AxiosInstance } from 'axios';
import { doGetProvider, type U3202ProviderGet } from '../U3202Service';

export async function u3202LoadProviderDetail(
  axios: AxiosInstance,
  providerId: string,
): Promise<U3202ProviderGet> {
  const response = await doGetProvider(axios, providerId);
  return response.data?.result as U3202ProviderGet;
}

/** @deprecated BL-0147 : un seul GET providers/:id */
export async function u3202LoadOrgProviderConfigDetail(axios: AxiosInstance, configId: string) {
  const provider = await u3202LoadProviderDetail(axios, configId);
  return { config: provider, provider };
}
